import {
  GlassButton,
  GlassCard,
  GlassCardContent,
  GlassInput,
  GradientMesh,
} from '@merritrac/shared/components';
import { KeyRound } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from '../lib/auth.js';

import type { ReactElement } from 'react';

export function LoginPage(): ReactElement {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login, error } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setSubmitting(true);
    const ok = await login(email, password);
    setSubmitting(false);
    if (ok) {
      void navigate('/');
    }
  }

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      <GradientMesh />
      <div className="w-full max-w-sm relative z-10">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary/20 shadow-[0_0_20px_var(--primary)] mb-3">
            <svg
              viewBox="0 0 32 32"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              className="w-7 h-7 text-primary"
            >
              <line x1="16" y1="4" x2="16" y2="28" />
              <line x1="4" y1="16" x2="28" y2="16" />
              <line x1="7" y1="7" x2="25" y2="25" />
              <line x1="25" y1="7" x2="7" y2="25" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-text">MerriTrac</h1>
          <p className="text-sm text-text-secondary mt-1">Admin Dashboard</p>
        </div>

        <GlassCard glow>
          <GlassCardContent className="pt-6 pb-6">
            <form
              onSubmit={(e): void => {
                void handleSubmit(e);
              }}
              className="space-y-4"
            >
              <GlassInput
                label="Email"
                type="email"
                placeholder="admin@merritrac.com"
                value={email}
                onChange={(e): void => {
                  setEmail(e.target.value);
                }}
                required
                autoComplete="email"
              />

              <GlassInput
                label="Password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e): void => {
                  setPassword(e.target.value);
                }}
                required
                autoComplete="current-password"
              />

              {error !== null && (
                <div className="flex items-center gap-2 px-3 py-2 rounded-lg glass border-danger/30 text-danger-fg text-sm">
                  <KeyRound size={14} />
                  <span>{error}</span>
                </div>
              )}

              <GlassButton type="submit" className="w-full" disabled={submitting}>
                {submitting ? 'Signing in\u2026' : 'Sign In'}
              </GlassButton>
            </form>
          </GlassCardContent>
        </GlassCard>

        <p className="mt-6 text-center text-xs text-text-tertiary">
          Field Service Management Platform &middot; v1.0.0
        </p>
      </div>
    </div>
  );
}
